import type { PlatformAdmin } from './auth-api';

export interface PlatformSession {
  accessToken: string;
  admin: PlatformAdmin;
}

const KEY = 'logistech.platform.session';

// sessionStorage (diagnostic 9.4a) : survit au F5, disparaît avec l'onglet ; jeton d'accès 1 h, sans refresh
export const sessionStore = {
  get(): PlatformSession | null {
    try {
      const raw = window.sessionStorage.getItem(KEY);
      return raw ? (JSON.parse(raw) as PlatformSession) : null;
    } catch {
      return null;
    }
  },
  set(s: PlatformSession): void {
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify(s));
    } catch {
      // Stockage bloqué (navigation privée stricte) : la session reste en mémoire jusqu'au rechargement
    }
  },
  clear(): void {
    try {
      window.sessionStorage.removeItem(KEY);
    } catch {
      // idem
    }
  },
};
